<script>
    import { onMount } from 'svelte';
    import { db, functions, breakId, loggedInUsers } from './stores.js';
    import Chat from './components/Chat.svelte';

    // let breakId = "";
    let sessionId;
    let conversationId;
    let jwt;
    let token;
    let apiKey;

    let session;

    let isPublishing = false;
    let audioSources = [{deviceId: null, kind: "audioInput", label: "no audio"}];
    let videoSources = [{deviceId: null, kind: "videoInput", label: "no video"}]
    let selectedAudio;
    let selectedVideo;
    let cameraContainer;
    let publisher;
    let screensharePublisher;

    let mediaStream;

    let role = "host";

    let breakStatus = "";

    let isSharing = false;

    let status = "";

    let isConnected = false;

    let isBroadcasting = false;
    let broadcast;
    let broadcastStatus = "";
    let archive;

    let timer;

    let audioLevel;
    let meter;

    let link = "";
    let links = [];
    let addLinkStatus = "";


    $: invitedUsers = $loggedInUsers.filter(user => user.breakId === $breakId && user.isInvited === true);

    // Get the list of devices and populate the drop down lists
    function populateDeviceSources() {
        console.log('populateDeviceSources');
        OT.getDevices((err, devices) => {
            if (err) {
                alert('getDevices error ' + err.message);
                return;
            }
            audioSources = [...audioSources, ...devices.filter(device => device.kind === 'audioInput')]
            videoSources = [...videoSources, ...devices.filter(device => device.kind === 'videoInput')]
            return;
        });
    }

    onMount (async ()=> {
        // We request access to Microphones and Cameras so we can get the labels
        OT.getUserMedia().then((stream) => {
            console.log('Camera onMount! stream: ', stream);
            mediaStream = stream;
            populateDeviceSources();
            // Stop the tracks so that we stop using this camera and microphone
            // If you don't do this then cycleVideo does not work on some Android devices
            stream.getTracks().forEach(track => track.stop());
        });
        // Get the token to connect to the session

    });


    function createBreak(){
        console.log("create Break");
        breakStatus = "creating break session..."
        // $db.collection("breaks").add({
        //     OTsession: null
        // }).then((docRef) => {
        //     console.log("Break session successfully created: ", docRef.id);
        //     breakId = docRef.id;
        // }).catch((error) => {
        //     console.log("Error in creating Break session: ", error);
        //     breakId = error;
        // });
        // do it in the back end 
        const title =  `break session ${Date.now()}`;
        const createBreakSession = $functions.httpsCallable('createBreakSession');
        createBreakSession({title})
            .then((result) => {
                console.log("createBreakSession result: ", result);
                breakId.set(result.data.breakId);
                jwt = result.data.jwt;
                token = result.data.token;
                breakStatus = `Success! id:${$breakId}`;

                $db.collection("breaks").doc($breakId)
                .onSnapshot((doc) => {
                    console.log("current data!: ", doc.data());
                    conversationId = doc.data().conversationId;
                    sessionId = doc.data().sessionId;
                    apiKey = doc.data().apiKey;

                    session = OT.initSession(apiKey, sessionId);
                    console.log("session: ",session);


                    // Subscribe to a newly created stream
                    session.on('streamCreated', function(event) {
                        console.log("streamCreated");
                        if (event.stream.videoType === 'screen'){
                            console.log("streamCreated screenshare");
                            session.subscribe(event.stream, 'screenshare-container', {
                            insertMode: 'append',
                            width: '100%',
                            height: '100%',
                            fitMode: 'contain'
                            }, (error) => {
                                if (error){
                                    console.log("streamCreated Error: ", error);
                                    status = `got an error: ${error}`;
                                } else {
                                    isSharing = true;
                                }
                            });

                        } else {

                            session.subscribe(event.stream, 'subscriber', {
                            insertMode: 'append',
                            width: '100%',
                            height: '100%'
                            }, (error) => {
                                if (error){
                                    console.log("streamCreated Error: ", error);
                                    status = `got an error: ${error}`;
                                } else {

                                }
                            });
                        }
                    });

                    session.on("streamDestroyed", function(event) {
                        console.log("Stream " + event.stream.name + " ended. " + event.reason);
                        if (event.stream.videoType === 'screen'){
                            isSharing = false;
                        }
                    });


                    // session.publish(publisher);
                    // session.connect(token, (error) => {
                    //     // If the connection is successful, publish to the session
                    //     if (error) {
                    //         console.error("error connecting to session: ", error);
                    //     } else {
                    //         // session.publish(publisher, (error) => {
                    //         //     if(error) {
                    //         //         console.error("error publishing to session: ", error);
                    //         //     } else {
                    //         //         isPublishing = true;
                    //         //     }
                    //         // });
                    //     }
                    // });




                });

            }).catch((error)=>{
                console.log("createBreakSession error: ", error);
            });

    };

    function setupAudioLevelMeter() {
        // const audioLevel = document.querySelector('#audio-meter');
        // const meter = document.querySelector('#audio-meter meter');
        // audioLevel.style.display = 'block';
        let movingAvg = null;
        publisher.on('audioLevelUpdated', (event) => {
        if (movingAvg === null || movingAvg <= event.audioLevel) {
            movingAvg = event.audioLevel;
        } else {
            movingAvg = 0.7 * movingAvg + 0.3 * event.audioLevel;
        }

        // 1.5 scaling to map the -30 - 0 dBm range to [0,1]
        let logLevel = (Math.log(movingAvg) / Math.LN10) / 1.5 + 1;
        logLevel = Math.min(Math.max(logLevel, 0), 1);
        meter.value = logLevel;
        });
    }


    function startPublishing() {
        console.log('start Publishing');
        publisher = OT.initPublisher('publisher',{
            audioSource: selectedAudio,
            videoSource: selectedVideo,
            // width: '1280px',
            // height: '720px',
            width: '100%',
            height: '100%',
            resolution: '1280x720',
            name: `${role}-camera`
        }, (err) => {
            if(err){
                alert('Publish error ' + err.message);
            } else {
                isPublishing = true;
                // session.publish(publisher, (error) => {
                //     if(error) {
                //         console.error("error publishing to session: ", error);
                //     } else {
                //         isPublishing = true;
                //     }
                // });

                // setupDeviceSwitching();
                setupAudioLevelMeter();
            }
        });


        // Connect to session

        // // session.publish(publisher);
        console.log("start Publishing session: ",session);
        if (!isConnected){
            session.connect(token, (error) => {
                // If the connection is successful, publish to the session
                if (error) {
                    console.error("error connecting to session: ", error);
                } else {
                    isConnected = true;
                    session.publish(publisher, (error) => {
                        if(error) {
                            console.error("error publishing to session: ", error);
                        } else {
                            // isPublishing = true;
                        }
                    });
                }
            });

        } else {
            console.log("already connected! just publish!")
            session.publish(publisher, (error) => {
                if(error) {
                    console.error("error publishing to session: ", error);
                } else {
                    // isPublishing = true;
                }
            });

        }

        publisher.on('streamCreated', (event) => {
            console.log('publisher streamCreated! ',event);
            // dispatch('streamCreated', {
            //     sources: {selectedAudio, selectedVideo, name:`${role}-camera`, streamId:publisher.streamId, connection:event.stream.connection}
            // })
        });
        publisher.on('destroyed', (event) => {
            console.log('publisher stream Destroyed! ',event);
            // dispatch('streamDestroyed', {
            //     sources: {selectedAudio:null, selectedVideo:null, name:`${role}-camera`}
            // })
        });
        // Listen to signals in the session
        session.on("signal", function(event) {
            console.log("Signal sent from connection " + event.from.id);
            console.log("Event Data " + event.data);
            // Process the event.data property, if there is any data.
            switch (event.data) {
                case 'mutePublisher':
                    console.log('mute publisher');
                    publisher.publishAudio(false);
                    break;
                case 'unmutePublisher':
                    console.log('unmute publisher');
                    publisher.publishAudio(true);
                    break;
                default:
                    console.log(`Sorry fam, don't know what ${event.detail.sources.name} is.`);
            }

        });

    }

    function recreatePublisherEl(){
        const publisherEl = document.createElement('div');
        publisherEl.id = "publisher";
        cameraContainer.appendChild(publisherEl);
    }

    function stopPublishing(){
        console.log('stop Publishing!');
        mediaStream.getTracks().forEach(track => {console.log('track: ', track); track.stop()});
        publisher.destroy();
        // if (session) {
        //     console.log("session disconnect!");
        //     session.disconnect();
        // }
        recreatePublisherEl();
        console.log('mediaStream: ',mediaStream);
        // mediaStream.getTracks().forEach(track => track.stop());
        // OT.getUserMedia().then((stream) => {
        //     console.log('Camera onMount! stream: ', stream)
        //     populateDeviceSources();
        //     // Stop the tracks so that we stop using this camera and microphone
        //     // If you don't do this then cycleVideo does not work on some Android devices
        //     stream.getTracks().forEach(track => track.stop());
        // });


        // populateDeviceSources();
        isPublishing = false;
    }

    function startScreensharing(){
        console.log('start screen sharing');

        OT.checkScreenSharingCapability(function(response) {
            if(!response.supported || response.extensionRegistered === false) {
                // This browser does not support screen sharing.
            } else if (response.extensionInstalled === false) {
                // Prompt to install the extension.
            } else {
                // Screen sharing is available. Publish the screen.
                screensharePublisher = OT.initPublisher('screenshare-container',
                {videoSource: 'screen',
                maxResolution: { width: 1920, height: 1080},
                fitMode: 'contain',
                insertMode: "append",
                width:'100%',
                height:'100%'
                },
                function(error) {
                    if (error) {
                        // Look at error.message to see what went wrong.
                    } else {
                        session.publish(screensharePublisher, function(error) {
                            if (error) {
                            // Look error.message to see what went wrong.
                            } else {
                                isSharing = true;
                            }
                        });
                    }
                });
            }
        });        
        
    }

    function stopScreensharing(){
        screensharePublisher.destroy();
        isSharing = false;
    }

    function disconnect(){
        if (session) {
            console.log("session disconnect!");
            session.disconnect();
            isConnected = false;
        }

    }

    function showVideo(uid){
        console.log("show Video: ",uid);
        $db.collection("users").doc(uid).set({
            showVideo: true
        },{ merge: true }).then(()=>{
            console.log("Succesfully update showVideo.")
        }).catch((error) => {
            console.error("Error updating showVideo: ", error)
        });
    }

    function hideVideo(uid){
        console.log("hide Video: ",uid);
        $db.collection("users").doc(uid).set({
            showVideo: false
        },{ merge: true }).then(()=>{
            console.log("Succesfully update showVideo.")
        }).catch((error) => {
            console.error("Error updating showVideo: ", error)
        });
    }

    function startBroadcastHandler(){
        console.log('startBroadcastHandler!');
        broadcastStatus = 'Starting...';
        const startBroadcast = $functions.httpsCallable('startBroadcast');
        startBroadcast({sessionId: sessionId, name: "untilitworks", breakId: $breakId})
            .then(function(result){
                console.log('startBroadcastHandler result: ',result);
                broadcast = result.data.broadcast;
                broadcastStatus = broadcast.status;
                archive = result.data.archive;
                console.log('got the archive!: ', archive);
                // isBroadcasting = true;

                if (broadcast.broadcastUrls) {
                    // Show YouTube confirmation modal
                    // showYouTubeConfirm = true;
                    $db.collection('breaks').doc($breakId).set({ status:"live", livestream:broadcast.broadcastUrls.hls }, { merge: true })
                    .then(function() {
                        isBroadcasting = true;
                        $db.collection('data').doc('status').set({
                            break_session: {
                                id:$breakId,
                                conversationId,
                                livestream:broadcast.broadcastUrls.hls
                            }
                        }, { merge: true }).then(()=>{
                            console.log("Successfully updated status with breakId")
                        }).catch((error)=>{
                            console.log('Error updating status: ', error);
                            broadcastStatus = 'Error - see console';
                        });
                    })
                    .catch(function(error) {
                        console.log('Error saving to database: ', error);
                        broadcastStatus = 'Error - see console';
                    });
                }
            })
            .catch(function(error){
                console.log('Error starting broadcast: ',error);
                broadcastStatus = 'Error - see console';
            });
    }

    function stopBroadcastHandler(){
        console.log('stopBroadcastHandler!');
        broadcastStatus = 'Stopping...';
        const stopBroadcast = $functions.httpsCallable('stopBroadcast');
        stopBroadcast({broadcastId: broadcast.id, archiveId: archive.id})
            .then(function(result){
                console.log('stopBroadcastHandler result: ',result);
                // broadcastStatus = result.data.broadcast.status;

                if (broadcast.broadcastUrls) {
                    $db.collection('breaks').doc($breakId).set({ status:"past", livestream:'' }, { merge: true })
                        .then(function() {
                            isBroadcasting = false;
                            broadcastStatus = result.data.broadcast.status;

                        })
                        .catch(function(error) {
                            console.log('Error saving to database: ', error);
                            broadcastStatus = 'Error - see console';
                        });
                }

            })
            .catch(function(error){
                console.log('Error stopping broadcast: ',error);
                broadcastStatus = 'Error - see console';
            });
    }

    function setTimer(duration){
        console.log("setTimer duration: ",duration);
        const newTime = Date.now() + duration;
        $db.collection("breaks").doc($breakId).set({
            speaker_timer: newTime
        },{ merge: true }).then(()=>{
            console.log("Succesfully update speaker timer.");
            if (timer) {
                timer.restart(newTime);
            }

        }).catch((error) => {
            console.error("Error updating speaker timer: ", error)
        });
    }

    function addLink(){
        console.log("addLink: ", link);
        links = [...links,  link];
        addLinkStatus = "link added";
        link = "";
    }

    function saveLinks(){
        console.log("saveLinks: ", links);
        $db.collection("breaks").doc($breakId).set({
            links
        },{ merge: true }).then(()=>{
            console.log("Succesfully saved links.");
            addLinkStatus = "links saved";

        }).catch((error) => {
            console.error("Error saving links: ", error);
            addLinkStatus = error;
        });

    }


</script>

<section>
    <div id="chat-qs-container">
        {#if conversationId}
            <Chat conversationId = {conversationId}/>
        {:else}
            create break to load chat and questions
        {/if}
    </div>
    <div id="broadcast-container">
        <div id="video-container">
            <div id="screenshare-container" class:sharing={isSharing === true}></div>
            <div id="camera-container" bind:this={cameraContainer}>
                <div id="subscriber"></div>
                <div id="publisher"></div>
            </div>
        </div>
        <div id="controls-container">
            <div id="media">
                <fieldset>
                    <legend>media</legend>
                    <label for="audio-source-select">Audio Source:</label>
                    <select bind:value={selectedAudio} disabled={isPublishing}>
                        {#if audioSources}
                            {#each audioSources as audioSource}
                                <option value="{audioSource.deviceId}">{audioSource.label || audioSource.kind }</option>
                            {/each}
                        {/if}
                    </select>
                    <br/>
                    <label for="video-source-select">Video Source:</label>
                    <select bind:value={selectedVideo} disabled={isPublishing}>
                        {#if videoSources}
                            {#each videoSources as videoSource}
                                <option value="{videoSource.deviceId}">{videoSource.label || videoSource.kind }</option>
                            {/each}
                        {/if}
                    </select>
                    {#if isPublishing}
                        <button id="stop-stream" type="button" on:click={stopPublishing}>Stop stream</button>
                    {:else}
                        <button id="publish-btn" type="button" on:click={startPublishing}>Publish</button>
                    {/if}
                    <div id="audio-meter" bind:this={audioLevel}>
                        <label for="audio-meter">Audio Level:</label>
                        <meter min="0" max="1" bind:this={meter}></meter>
                    </div>
            
                    <br/><button id="disconnect" type="button" on:click={disconnect}>Disconnect</button>
                    
                    <br/><button on:click={ startScreensharing }>start screenshare</button>
                    <button on:click={ stopScreensharing }>stop screenshare</button>
                </fieldset>
                <fieldset>
                    <legend>timer</legend>
                    <dwane-timer bind:this={timer} timer-deadline="0" countdown-start="3600000" timer-orientation="horizontal"></dwane-timer>
                    <br/><button on:click={ () => setTimer(300000)}>set 5 mins</button>
                    <button on:click={ () =>setTimer(600000) }>set 10 mins</button>
                </fieldset>
            </div>
            <div id="stream">
                <fieldset>
                    <legend>stream</legend>
                    <br/><button on:click={ createBreak }>create break</button>
                    <br/>{breakStatus}
                    <br/><button on:click={ startBroadcastHandler }>start broadcast</button>
                    <br/><button on:click={ stopBroadcastHandler }>stop broadcast</button>
                    <br/>{broadcastStatus}
                </fieldset>
                <fieldset>
                    <legend>add link</legend>
                    <input bind:value={link}>
                    <br/><button on:click={ addLink }>add link</button> <button on:click={ saveLinks }>save links</button>
                    <br/>{addLinkStatus}
                    <br/>links:
                    <ul>
                        {#each links as link}
                            <li>{link}</li>
                        {/each}
                    </ul>



                </fieldset>

            </div>
            <div id="publish">
                <fieldset>
                    <legend>guest</legend>
                    {#each invitedUsers as user (user.uid)}
                        <br/><a href="https://{user.provider}/{user.username}" target="_blank">{user.username}</a>
                        {#if user.showVideo}
                            <button on:click={() => hideVideo(user.uid)}>hide video</button>
                        {:else}
                            <button on:click={() => showVideo(user.uid)}>show video</button>
                        {/if}
                    {/each}
                </fieldset>
            </div>
        </div>
    </div>
</section>

<style>
    section {
        display: flex;
        width: 100%;
        height: 100%;
        justify-content: center;
        align-items: center;
    }

    #chat-qs-container {
        width: 500px;
    }

    #broadcast-container {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    #video-container {
        display: flex;
        height: 100%;
        width: 100%;
    }

    #camera-container {
        display: grid;
        grid-gap: 1rem;
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        height: 100%;
        width: 100%;

    }

    #controls-container {
        display: flex;
        width: 100%;
        justify-content: space-around;
    }

    legend {
        text-align: left;
        background-color: #fff;
        color: #000;
        padding: 3px 6px;
        font-weight: bold;
    }

    #publish {
        display: flex;
    }

    button {
        cursor: pointer;
    }

    #screenshare-container {
        width:0;
    }

    #screenshare-container.sharing {
        width: 100%;
    } 

    dwane-timer {
        --dwane-timer-font-family: "Roboto Mono";
        --dwane-timer-weekday-font-size: clamp(1.5rem, 1.5vw, 2rem);
        --dwane-timer-date-font-size: clamp(1.5rem, 1.5vw, 2rem);
        --dwane-timer-time-font-size: clamp(1.5rem, 1.5vw, 2rem);
        --dwane-timer-countdown-font-size: clamp(5rem, 1.5vw, 9rem);
        --dwane-timer-text-color: black;
        opacity: 0;
        transition:opacity 0.4s ease-in;
    }
    dwane-timer:defined {
        opacity: 1;
    }

</style>